import { render, staticRenderFns } from "./admissionForms.vue?vue&type=template&id=4d1f009e"
import script from "./admissionForms.vue?vue&type=script&lang=js"
export * from "./admissionForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports